import { cx } from '@twind/core';
import img from 'app/assets/icons/single-select-arrow.svg';

import { useContactFormLinkClick } from '../hooks/useContactFormLinkClick';
import { FormItemSingleChoice } from '../types';
import Select from './Select/Select';

type Props = { item: FormItemSingleChoice; isSubmitted: boolean; contactFormSlug?: string };

export function ContactFormSingleChoice({ item, isSubmitted, contactFormSlug }: Props) {
  const { handleLinkClick } = useContactFormLinkClick(contactFormSlug);
  const hasErrors = !!item.errors?.length;
  const showError = isSubmitted && hasErrors;
  const errorId = `contact-form-single-choice-error-${item.ref_id}`;

  return (
    <div className="ostro-contact-form-single-choice flex flex-col gap-2">
      <div className="flex items-center text-sm gap-1">
        <label
          htmlFor={item.ref_id}
          dangerouslySetInnerHTML={{ __html: item.label }}
          onClick={handleLinkClick}
          className="flex items-center"
        />
        {!item.required && <span>(optional)</span>}
      </div>
      <Select
        id={item.ref_id}
        name={item.ref_id}
        defaultValue={typeof item.value === 'string' ? item.value : undefined}
        style={{
          backgroundImage: `url(${img})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 10px center',
        }}
        required={item.required}
        className={cx(
          'px-[14px] py-3 border md:text-sm rounded-[8px] hide-select-arrow w-full',
          showError ? 'border-[#FF3323] outline-[#FF3323]' : 'border-typography-divider outline-typography-divider'
        )}
        aria-invalid={showError}
        aria-describedby={showError ? errorId : undefined}
      >
        {item.choices.map((choice: string) => (
          <option key={choice}>{choice}</option>
        ))}
      </Select>
      {showError && (
        <div
          className="text-xs -mt-1 text-[#FF3323]"
          id={errorId}
        >
          {item.errors?.join(', ')}
        </div>
      )}
    </div>
  );
}
